<template>
    <div class="phone-number-container" :class="{'phone-number-with-extension': !!extensionField}">
        <masked-input
            type="tel"
            ref="input"
            :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
            :guide="true"
            :value="value"
            :disabled="!editable"
            @input="changed"
        />
        <input
            v-if="!!extensionField"
            type="text"
            ref="extension"
            :name="extensionField"
            :value="extension"
            :placeholder="editable?'Ext.':''"
            :disabled="!editable"
            @blur="changed_extension"
        />
    </div>
</template>

<script type="text/javascript">
import is_nibnut_component from "../mixins/IsNibnutComponent"

import MaskedInput from "vue-text-mask"

export default {
    mixins: [is_nibnut_component],
    components: {
        MaskedInput
    },
    methods: {
        saved_value (phone) {
            return phone ? phone.replace(/[^\d]+/g, "") : ""
        },
        changed (phone) {
            const saved_value = this.saved_value(phone)
            if(this.editable && (this.value !== saved_value)) this.$emit("input", saved_value, this.name)
        },
        changed_extension (event) {
            if(this.editable) this.$emit("input", event.target.value, this.extensionField)
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        extensionField: {
            type: String,
            default: ""
        },
        extension: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            phone: null
        }
    }
}
</script>

<style lang="less">
    .phone-number-container{
        input[type=tel] {
            width: 100%;
        }

        &.phone-number-with-extension {
            input[type=tel] {
                width: 75%;
            }
            input[type=text] {
                margin-left: -4px;
                width: 25%;
            }
        }
    }
</style>
